import React, { useState } from "react";
import { getLabelDrawerKey, getNestedDrawerOpen, setNestedDrawerOpen } from "./drawerState.js";
import { StaticTextLabel } from "./StaticTextLabel.js";

function resolveStaticImageTextDrawerChildLabels(props, allLabels = []) {
  if (props.childTextLabels && props.childTextLabels.length > 0) {
    return props.childTextLabels
      .map((childLabel) => {
        if (childLabel && typeof childLabel === "object") {
          return childLabel;
        }

        return allLabels.find((label) => label.id === childLabel);
      })
      .filter((label) => label !== undefined);
  }

  return allLabels.filter((label) => label.type === "STATIC_TEXT_LABEL" && label.parentImageId === props.id);
}

function getAllLabelsForStaticImageTextDrawer() {
  if (typeof Inventum === "undefined" || !Inventum.labels || typeof Inventum.labels.getLabels !== "function") {
    return [];
  }

  return Inventum.labels.getLabels();
}

function ImageTextPanel(props) {
  const drawerKey = `image-text:${props.id}`;
  const [open, setOpen] = useState(() => getNestedDrawerOpen(drawerKey));

  const toggleOpen = () => {
    setOpen((currentOpen) => {
      const nextOpen = !currentOpen;
      setNestedDrawerOpen(drawerKey, nextOpen);
      return nextOpen;
    });
  };

  return (
    <div>
      <div className="EditorDrawerItemHeader" onClick={toggleOpen}>
        <span className="PanelOpenStatus">{open ? "▾" : "▸"}</span>
        <span>Image Text</span>
        {props.childTextLabels && props.childTextLabels.length > 0 && (
          <span style={{ fontSize: "10px", marginLeft: "5px", color: "#ccc" }}>({props.childTextLabels.length})</span>
        )}
      </div>
      {open ? <StaticImageTextDrawer {...props} /> : null}
    </div>
  );
}

function StaticImageTextDrawer(props) {
  const childLabels = resolveStaticImageTextDrawerChildLabels(props, getAllLabelsForStaticImageTextDrawer());
  const handleAddTextAbove = () => {
    Inventum.labels.addTextToFigureImage(props.id, "above");
    setTimeout(() => {
      props.getLabels();
    }, 50);
  };

  const handleAddTextBelow = () => {
    Inventum.labels.addTextToFigureImage(props.id, "below");
    setTimeout(() => {
      props.getLabels();
    }, 50);
  };

  const handleChangeTextPosition = (textId, newPosition) => {
    Inventum.labels.changeTextPosition(textId, props.id, newPosition);
    setTimeout(() => {
      props.getLabels();
    }, 10);
  };

  const handleGetLabels = () => {
    props.getLabels();
  };

  if (childLabels.length === 0) {
    return (
      <div className="image-text-drawer">
        <div className="image-text-no-labels">
          <span>No text labels yet</span>
        </div>
        <div className="image-text-no-labels-buttons">
          <button className="image-text-add-btn" onClick={handleAddTextAbove} title="Add Text Above Image">
            <i className="material-icons notranslate">vertical_align_top</i> Above
          </button>
          <button className="image-text-add-btn" onClick={handleAddTextBelow} title="Add Text Below Image">
            <i className="material-icons notranslate">vertical_align_bottom</i> Below
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="image-text-drawer">
      <div className="image-text-header">
        <span>Text Labels ({childLabels.length})</span>
        <div className="image-text-header-buttons">
          <button className="image-text-header-btn above" onClick={handleAddTextAbove} title="Add Text Above Image">
            <i className="material-icons notranslate">vertical_align_top</i>
          </button>
          <button className="image-text-header-btn" onClick={handleAddTextBelow} title="Add Text Below Image">
            <i className="material-icons notranslate">vertical_align_bottom</i>
          </button>
        </div>
      </div>
      <div className="image-text-children">
        {childLabels.map((child) => (
          <div key={child.id} className="image-text-child">
            <div className="image-text-child-header">
              <span className="image-text-position-indicator">{child.textPosition === "above" ? "↑ Above" : "↓ Below"}</span>
              <span
                onClick={() => handleChangeTextPosition(child.id, child.textPosition === "above" ? "below" : "above")}
                className="image-text-switch-btn"
                title={`Move ${child.textPosition === "above" ? "below" : "above"} image`}>
                Switch
              </span>
            </div>
            <StaticTextLabel getLabels={handleGetLabels} labelDrawerKey={getLabelDrawerKey(child)} {...child} />
          </div>
        ))}
      </div>
    </div>
  );
}

export { ImageTextPanel, resolveStaticImageTextDrawerChildLabels };
